import { useTranslation } from 'react-i18next';
import styles from './ContactForm.module.css';
import { useContext, useState } from 'react';
import { UserContext } from 'context/userContext';
import { useForm } from 'react-hook-form';
import { TWO_WORDS_REGEX, VALIDATION_EMAIL_REGEX } from 'config/constants';
import { ContactFormData } from 'types/ContactFormData';
import { contact } from 'services/api/miscellaneousService';
import { InfoWrapper } from '../InfoWrapper/InfoWrapper';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import { useNavigate } from 'react-router-dom';

export const ContactForm = () => {
  const { t } = useTranslation();
  const { loggedUser } = useContext(UserContext);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ContactFormData>();
  const navigate = useNavigate();

  const handleFormSubmit = async (data: ContactFormData) => {
    await contact(data);
    reset();
    setFormSubmitted(true);
  };

  return (
    <>
      {formSubmitted ? (
        <div className={styles.infoWrapper}>
          <InfoWrapper
            onClose={() => navigate('/')}
            closeButtonText="OK"
            closeButtonIconClass="mobile-css-icons checkmark"
          >
            <div className={styles.infoContent}>
              <ThemeIcon icon="success-checkmark" alt="Info" variant="inline" />{' '}
              {t('contact_success_message')}
            </div>
          </InfoWrapper>
        </div>
      ) : (
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className={styles.formField}>
            <div>{t('username')}:</div>
            <input
              type="text"
              placeholder={t('username')}
              value={loggedUser?.username ?? undefined}
              {...register('username')}
            />
          </div>
          <div className={styles.formField}>
            <div>{t('your_email_address_label')}:</div>
            <input
              type="text"
              placeholder={t('your_email_address_label')}
              {...register('email', {
                required: true,
                pattern: VALIDATION_EMAIL_REGEX,
              })}
              className={errors.email ? styles.error : undefined}
            />
          </div>
          <div className={styles.formField}>
            <div>{t('subject_problem_label')}:</div>
            <input
              type="text"
              placeholder={t('subject_problem_label')}
              {...register('subject', { required: true })}
              className={errors.subject ? styles.error : undefined}
            />
          </div>
          <div className={styles.formField}>
            <div>{t('message_label')}:</div>
            <textarea
              placeholder={t('message_label')}
              {...register('content', {
                required: true,
                minLength: 3,
                pattern: TWO_WORDS_REGEX,
              })}
              className={errors.content ? styles.error : undefined}
            />
          </div>
          <div className={styles.buttonWrapper}>
            <button>
              {t('send_label')}
              <ThemeIcon
                icon="contact"
                alt=""
                variant="inline"
                className={styles.contactIcon}
              />
            </button>
          </div>
        </form>
      )}
    </>
  );
};
